import { IAudit } from '@alberta/konexi-shared';
import { AssetLoadable, ImageItem } from '@alberta/swodoc-document-generator';
import { IAttachmentService } from '@services/attachment/attachment-service.interface';
import { AttachmentComponentModel } from 'src/app/business/attachment/attachment-component-model';
import { AttachmentDto } from 'src/app/shared/models/attachment/attachment-dto.model';

export class AuditAssetLoader implements AssetLoadable {
  constructor(
    private readonly attachmentModel: AttachmentComponentModel,
    private readonly attachmentService: IAttachmentService
  ) {}

  public async load(audit: IAudit): Promise<ImageItem[]> {
    const assets = await this.getAssets(audit);
    return this.mapAssets(assets);
  }

  private async getAssets(audit: IAudit): Promise<Array<Partial<ImageItem>>> {
    const assets = await new Promise<AttachmentDto[]>(resolve => {
      this.attachmentModel
        .search(`metadata.auditId:${audit._id} metadata.templateId:${audit.templateId}`, {
          isIn: true,
          ignoreRegionIds: true,
          ignoreOnlineSearch: true,
        })
        .subscribe(items => resolve(items));
    });

    await this.attachmentService.save(assets);

    return assets as unknown as ImageItem[];
  }

  private async mapAssets(assets: Array<Partial<ImageItem>>): Promise<ImageItem[]> {
    return Promise.all(
      assets.map(async asset => {
        const b64 = (await this.attachmentService.get(asset._id, 'base64')) as string;
        return { ...asset, data: b64 } as ImageItem;
      })
    );
  }
}
